import React, { Component } from "react"
import { Redirect, Route, Switch } from "react-router-dom"
import MaterialModal from "app/components/normal/MaterialModal"

import { inject, observer } from "mobx-react"
import { Row } from "antd"
import "./Index.scss"
import "app/styles/sass/modal.scss"
import "app/styles/sass/base.scss"
import "app/styles/less/ant-theme-vars.less"
import config from "app/config"
import styled from 'styled-components'
import Main from 'app/pages/Main'
import Welcome from 'app/pages/Welcome'
import { setCurrentApp } from "./api/localTools"

const ZanXus = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  width: 80px;
  height: 80px;
  z-index: 999999;
`

@inject("auth", "entrance") @observer
class App extends Component {
  login = () => {
    window.location.href = `${config.urlPrefix}/start/login`
  }

  componentDidMount () {
    if (!/(login|download_chrome)$/.test(location.pathname)) {
      this.loadSource()
    }
  }

  loadSource = () => {
    const {auth, entrance} = this.props
    auth.loadUserInfo()
      .then(() => {
        entrance.getTemplates(auth.userInfo.orgId)
      })
  }

  render () {
    const {match} = this.props
    return (
      <div>
        <Switch>
          {/*入口型逻辑*/}
          <Route path={`${match.url}/start`} component={Welcome} />
          <Route path={`${match.url}/main`} component={Main} />
          <Redirect from="*" to={`${match.url}/start`} />
        </Switch>
        <MaterialModal
          visible={this.props.auth.locked}
          title="重新登录确认"
          buttnType="primary"
          buttonText="确认"
          action={this.login}>
          <Row className="normal-message" type="flex" justify="center" align="middle">
            由于您长时间未对页面进行任何操作，为了保证您的账户安全，请重新登录
          </Row>
          <Row type="flex" className="tiny-message" justify="center" align="middle">
            若不需要此功能，请前往右上角头像处“安全中心”关闭
          </Row>
        </MaterialModal>
        <ZanXus id='ZanXus' />
      </div>
    )
  }
}

export default class extends React.Component {
  componentWillMount () {
    const isChrome = this.isChrome()
    const href = window.location.pathname
    if (!isChrome && href !== "/public/start/download_chrome") {
      window.location.href = "/public/start/download_chrome"
    }
  }

  isChrome = () => {
    return /(chrome\/([\d.]+)|crios\/([\d.]+))/.test(navigator.userAgent.toLowerCase())
  }

  render () {
    return (
      <Switch>
        <Route path='/public' component={App} />
        <Redirect from='*' to='/public' />
      </Switch>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/index.js